export default __webpack_public_path__ + "static/media/logo-orinno-technology.f1e7bb76.png";